import { useEffect, useRef, useState } from 'react';
import './Navbar.css';

const CHROME_STORE_URL = 'https://chromewebstore.google.com/category/extensions';

const NAV_LINKS = [
    { href: '#how-it-works', label: 'How it works', chip: 'How it works' },
    { href: '#who', label: "Who it's for", chip: "Who it's for" },
    { href: '#pricing', label: 'Pricing', chip: 'Pricing' },
    { href: '#faq', label: 'FAQ', chip: 'FAQ' },
];

function Navbar() {
    const [activeHref, setActiveHref] = useState('');
    const visibleSections = useRef(new Map());

    useEffect(() => {
        const sections = NAV_LINKS
            .map((link) => document.getElementById(link.href.slice(1)))
            .filter(Boolean);

        if (sections.length === 0) return undefined;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        visibleSections.current.set(entry.target.id, entry.intersectionRatio);
                    } else {
                        visibleSections.current.delete(entry.target.id);
                    }
                });

                const ranked = [...visibleSections.current.entries()]
                    .sort((a, b) => b[1] - a[1]);

                setActiveHref(ranked[0] ? `#${ranked[0][0]}` : '');
            },
            {
                rootMargin: '-30% 0px -55% 0px',
                threshold: [0, 0.2, 0.4, 0.6],
            },
        );

        sections.forEach((section) => observer.observe(section));
        return () => observer.disconnect();
    }, []);

    return (
        <header className="al-header">
            <div className="al-shell al-header-inner">
                <a className="al-logo" href="#home">Numus</a>
                <nav className="al-nav" aria-label="Primary">
                    {NAV_LINKS.map((link) => (
                        <a
                            key={link.label}
                            className={activeHref === link.href ? 'is-active' : undefined}
                            href={link.href}
                            aria-current={activeHref === link.href ? 'true' : undefined}
                        >
                            {link.label}
                        </a>
                    ))}
                </nav>
                <div className="al-header-actions">
                    <a
                        className="al-btn al-btn--outline al-btn--nav"
                        href={CHROME_STORE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Get Started
                    </a>
                </div>
                <nav className="al-nav-chips" aria-label="Sections">
                    {NAV_LINKS.map((link) => (
                        <a
                            key={link.href}
                            className={`al-nav-chip${activeHref === link.href ? ' is-active' : ''}`}
                            href={link.href}
                            aria-current={activeHref === link.href ? 'true' : undefined}
                        >
                            {link.chip}
                        </a>
                    ))}
                </nav>
            </div>
        </header>
    );
}

export default Navbar;
